import { VFC, useMemo } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { P_MAX_LABELS, P_MAX_VALUES, Pmax } from '@enmon/commons';
import { Select } from '../../Select';
import { MeterDetails as messages } from '../../../Form/meter_details/messages';
import { useMeterModelSuggestionsStore } from '../../../../store/useMeterModelSuggestionsStore';
import { getSelectOptionsWithSuggestions } from '../../utils/getSelectOptionsWithSuggestions';

interface PMaxProps {
  value?: Pmax;
  onChange?: (value: Pmax) => void;
}

export const PMaxSelect: VFC<PMaxProps> = ({ ...restProps }) => {
  const intl = useIntl();
  const { meterModelSuggestions } = useMeterModelSuggestionsStore();

  const pMaxOptions = useMemo(
    () =>
      getSelectOptionsWithSuggestions({
        intl,
        values: P_MAX_VALUES,
        suggestedValue: meterModelSuggestions?.pMax?.value,
        suggestedSelection: meterModelSuggestions?.pMax?.selection,
        labelFormatter: (value: Pmax) => P_MAX_LABELS[value],
      }),
    [intl, meterModelSuggestions],
  );

  return (
    <Select
      allowClear
      showArrow
      className="w-100"
      options={pMaxOptions}
      placeholder={<FormattedMessage {...messages.pMaxPlaceholder} />}
      {...restProps}
    />
  );
};
